import React from 'react';
import styles from './TradeFilter.module.scss';
import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import moment from 'moment';
import PropTypes from 'prop-types';
import withRouter from '../../util/customWithRouter';
import { CheckBox, TextBox, NumberBox, SelectBox, DateBox, TagBox } from 'devextreme-react';
import List from 'devextreme-react/list';
import Tooltip from 'devextreme-react/tooltip';
import businessMoment from 'moment-business';
import { sideTypes, venueTypes, liquidityTypes, capacityTypes, filterDatePattern, filterTimePattern } from '../../util/tradeFilterConstants';
import { isEmpty, isEmptyArray } from '../../util/functions';
import { datePattern, timePattern } from '../../util/constants';
import { format } from '../../util/locale';

const formatDate = date => {
  return format(date, date, 'date');
};

const formatTime = time => {
  return format(time, time, 'time');
};

const disableAutoComplete = {
  autocomplete: 'off'
};

const newDate = new Date();

const initialState = {
  startDate: newDate,
  endDate: newDate,
  symbol: '',
  startTime: null,
  endTime: null,
  mpid: '',
  side: null,
  venue: null,
  orderCapacity: null,
  clientOrderId: '',
  execId: '',
  minSize: null,
  maxSize: null,
  liquidityIndicator: null
};

class TradeFilter extends React.Component {
  constructor (props) {
    const localStorageSearch = window.localStorage.getItem('recentTradeSearch');
    const recentSearches = localStorageSearch && JSON.parse(localStorageSearch);
    super(props);
    this.state = {
      ...initialState,
      errorMessages: [],
      collapseOnSearch: window.localStorage.getItem('tps_collapseSearch') === 'true',
      showFilter: true,
      isSymbolFocus: false,
      isMpidFocus: false,
      recentSymbolSearch: recentSearches && recentSearches.symbol,
      recentMpidSearch: recentSearches && recentSearches.mpid
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
    this.getTradeDataFilterAttributes = this.getTradeDataFilterAttributes.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRecentSearches = this.handleRecentSearches.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount () {
    const params = new URLSearchParams(this.props.router.location.search);
    const mpid = params.get('mpid') || '';
    const symbol = params.get('symbol') || '';
    if (mpid || symbol) {
      this.setState({
        mpid: mpid,
        symbol: symbol
      });
    }
  }

  componentDidUpdate (prevProps) {
    if (!isEmpty(this.props.startDateUpdate) && prevProps.startDateUpdate !== this.props.startDateUpdate) {
      var startDateUpdateValue = moment(this.props.startDateUpdate, 'YYYY-MM-DD').toDate();
      startDateUpdateValue.setHours(0, 0, 0, 0);
      this.setState({
        startDate: startDateUpdateValue
      });
    }
    if (!isEmpty(this.props.endDateUpdate) && prevProps.endDateUpdate !== this.props.endDateUpdate) {
      var endDateUpdateValue = moment(this.props.endDateUpdate, 'YYYY-MM-DD').toDate();
      endDateUpdateValue.setHours(23, 59, 0, 0);
      this.setState({
        endDate: endDateUpdateValue
      });
    }

    if (prevProps.mpidUpdate !== this.props.mpidUpdate && this.props.mpidUpdate) {
      this.setState({
        mpid: this.props.mpidUpdate
      });
    }

    if (prevProps.isDataLoaded !== this.props.isDataLoaded) {
      if (this.props.isDataLoaded && this.state.collapseOnSearch) {
        this.setState({ showFilter: false });
      }
    }
  }

  toggleFilter = () => this.setState(state => ({ showFilter: !state.showFilter }));

  handleListItemClick = (e, name) => {
    this.setState({
      isSymbolFocus: false,
      isMpidFocus: false,
      [name]: e.itemData
    });
  }

  showToolTip = label => {
    this.setState({
      [label]: true
    });
  }

  hideToolTip = label => {
    this.setState({
      [label]: false
    });
  }

  handleCopyValue = (param, value) => {
    this.setState({ [param]: this.state[value] });
  }

  handleChange (event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSearch () {
    this.handleSubmit('search');
  }

  handleDownload () {
    this.handleSubmit('download');
  }

  handleSubmit (type) {
    let queryParam = this.state;
    //  console.log(queryParam);
    var errorMessages = [];
    // start date is mandatory
    if (!('startDate' in queryParam) || queryParam['startDate'] === null) {
      errorMessages.push('Please select start date');
    }
    if (!('endDate' in queryParam) || queryParam['endDate'] === null) {
      errorMessages.push('Please select end date');
    }
    if (queryParam['endDate'] !== null && queryParam['startDate'] !== null) {
      if (queryParam['startDate'] > queryParam['endDate']) {
        errorMessages.push('Start date can not be greater than end date');
      } else {
        const fromDate = moment(queryParam['startDate']);
        const toDate = moment(queryParam['endDate']);
        const businessDaysDiff = businessMoment.weekDays(fromDate, toDate);
        // 90 business days logic
        if (businessDaysDiff > 90) {
          errorMessages.push('Date range must be within 90 business days. Please adjust your date range');
        }
      }
    }

    if (queryParam['minSize'] && queryParam['maxSize'] && queryParam['maxSize'] < queryParam['minSize']) {
      errorMessages.push('Min Trade size can not be greater than max trade size');
    }
    if (isEmpty(queryParam['symbol']) && isEmpty(queryParam['mpid']) &&
    isEmptyArray(queryParam['venue']) && isEmpty(queryParam['liquidityIndicator'])) {
      errorMessages.push('Please select Symbol or MPID or Venue or Liquidity Indicator ');
    }

    this.setState({ errorMessages: errorMessages });
    if (errorMessages.length === 0) {
      // put recent searches in the localstorage
      this.handleRecentSearches(queryParam);
      // try to get data
      let params = this.getTradeDataFilterAttributes(queryParam);
      this.props.search(params, type);
    }
  }

  handleRecentSearches (params) {
    const recentSearchStorage = window.localStorage.getItem('recentTradeSearch');

    let recentSearchData = {
      symbol: [],
      mpid: []
    };

    if (recentSearchStorage) {
      recentSearchData.symbol = JSON.parse(recentSearchStorage).symbol;
      recentSearchData.mpid = JSON.parse(recentSearchStorage).mpid;
    }

    const symbolField = params.symbol && params.symbol.toUpperCase();
    const mpidField = params.mpid && params.mpid.toUpperCase();
    if (symbolField && symbolField !== '') {
      if (!recentSearchData.symbol.includes(symbolField))recentSearchData.symbol.unshift(symbolField);

      if (recentSearchData.symbol.includes(symbolField)) {
        const symbolArray = recentSearchData.symbol;
        const index = symbolArray.indexOf(symbolField);
        symbolArray.splice(index, 1);
        symbolArray.unshift(symbolField);
      }
    }
    if (mpidField && mpidField !== '') {
      if (!recentSearchData.mpid.includes(mpidField))recentSearchData.mpid.unshift(mpidField);

      if (recentSearchData.mpid.includes(mpidField)) {
        const mpidArray = recentSearchData.mpid;
        const index = mpidArray.indexOf(mpidField);
        mpidArray.splice(index, 1);
        mpidArray.unshift(mpidField);
      }
    }
    if (recentSearchData.symbol.length > 10) recentSearchData.symbol.pop();

    if (recentSearchData.mpid.length > 10) recentSearchData.mpid.pop();

    window.localStorage.setItem('recentTradeSearch', JSON.stringify(recentSearchData));

    this.setState({
      isMpidFocus: false,
      isSymbolFocus: false,
      recentSymbolSearch: recentSearchData.symbol,
      recentMpidSearch: recentSearchData.mpid
    });
  }

  renderErrorMessages () {
    const errorMessages = this.state.errorMessages;
    return errorMessages.map((errorMessage, i) => <div key={`Error-${i}`}>{errorMessage}</div>);
  }

  getTradeDataFilterAttributes (queryParam) {
    var params = [];

    Object.keys(queryParam).forEach((key) => {
      let val = queryParam[key];
      if (val !== null) {
        if (key.toLowerCase().includes('date') && moment.isDate(val)) {
          params[key] = moment(val).format(datePattern);
        } else if (key.toLowerCase().includes('time') && moment.isDate(val)) {
          params[key] = moment(val).format(timePattern);
        } else if (typeof val === 'string') {
          if (val.trim() !== '') {
            params[key] = val;
          }
        } else {
          params[key] = val;
        }
      }
    });

    return params;
  }

  handleFocusIn (field) {
    this.setState({ [field]: true });
  }
  handleFocusOut (field) {
    setTimeout(() => { this.setState({ [field]: false }); }, 250);
  }

  handleCollapseOption = () => {
    this.setState(state => ({ collapseOnSearch: !state.collapseOnSearch }), () => window.localStorage.setItem('tps_collapseSearch', this.state.collapseOnSearch));
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.setState({
        isSymbolFocus: false,
        isMpidFocus: false
      });

      this.handleSubmit('search');
    };
  }

  renderCollapseDate = () => {
    const state = this.state;
    const isSameDate = state.startDate === state.endDate;
    const isfromTime = state.startTime;
    const istoTime = state.endTime;
    let time = '';

    if (isfromTime && istoTime) time = `${formatTime(isfromTime)}-${formatTime(istoTime)}`;
    if (isfromTime && !istoTime) time = `From ${formatTime(isfromTime)}`;
    if (!isfromTime && istoTime) time = `To ${formatTime(istoTime)}`;

    return `${isSameDate ? formatDate(state.startDate) : formatDate(state.startDate) + '-' + formatDate(state.endDate)} ${time}`;
  }

  renderCollapseSize= () => {
    const state = this.state;
    if (!state.minSize) { return '<= ' + state.maxSize; }
    if (!state.maxSize) { return '>= ' + state.minSize; }
    const isSameSize = state.maxSize === state.minSize;

    return `${isSameSize ? state.minSize : state.minSize + '-' + state.maxSize}`;
  }
  renderCollapseSide () {
    const sidesSelected = sideTypes.filter(item => this.state.side.includes(item.id));
    const sideString = sidesSelected.map(e => e.value).join(',');
    return sideString;
  }

  renderCollapseVenue () {
    const venueSelected = venueTypes.filter(item => this.state.venue.includes(item.id));
    const venueString = venueSelected.map(e => e.value).join(',');
    return venueString;
  }

  render () {
    const { recentSymbolSearch, recentMpidSearch } = this.state;
    const isSymbolFocus = this.state.isSymbolFocus && recentSymbolSearch;
    const isMpidFocus = this.state.isMpidFocus && recentMpidSearch;
    const isFilterOpen = this.state.showFilter;
    return (
      <div id='tradeFilter' className={styles.container}>
        <div className={styles.formContainer}>

          {isFilterOpen && <div className={styles.tradeGridStyle} onKeyDown={this.handleKeyDown}>

            <div key={'symbolKey'}>
              <Label title='Symbol' />
              <TextBox
                name={'symbol'} placeholder={'Symbol'} value={this.state['symbol']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isSymbolFocus')}
                onFocusOut={() => this.handleFocusOut('isSymbolFocus')}
                onValueChanged={(e) => this.handleChange(e, 'symbol')} />
              {isSymbolFocus && recentSymbolSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentSymbolSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'symbol')} />
              </div>}
            </div>

            <div key={'startDateKey'}>
              <Label title='Start Date' />
              <DateBox
                name={'startDate'}
                value={this.state['startDate']}
                placeholder={'MM/DD/YYYY'}
                useMaskBehavior
                openOnFieldClick
                max={new Date()}
                onValueChanged={(e) => this.handleChange(e, 'startDate')}
                displayFormat={filterDatePattern} /></div>

            <div key={'endDateKey'}>
              <div
                id='end-date-label'
                onMouseEnter={() => this.showToolTip('toDateToolTip')}
                onMouseLeave={() => this.hideToolTip('toDateToolTip')}
                onClick={() => this.handleCopyValue('endDate', 'startDate')}>
                <Label className={styles.labelButton} title='End Date' />

                <Tooltip
                  target='#end-date-label'
                  position='top'
                  visible={this.state.toDateToolTip}
                  hideOnOutsideClick={false}>
                    Copy Start Date
                </Tooltip>
              </div>
              <DateBox
                name={'endDate'}
                value={this.state['endDate']}
                placeholder={'MM/DD/YYYY'}
                useMaskBehavior
                openOnFieldClick
                max={new Date()}
                onValueChanged={(e) => this.handleChange(e, 'endDate')}
                displayFormat={filterDatePattern} /></div>

            <div key={'startTimeKey'}>
              <Label title='Start Time' />
              <DateBox
                type='time'
                name={'startTime'}
                value={this.state['startTime']}
                placeholder={'HH:mm:ss.SSS'}
                showClearButton
                useMaskBehavior
                showDropDownButton={false}
                onValueChanged={(e) => this.handleChange(e, 'startTime')}
                displayFormat={filterTimePattern} /></div>

            <div key={'endTimeKey'}>
              <div
                id='end-time-label'
                onMouseEnter={() => this.showToolTip('toTimeToolTip')}
                onMouseLeave={() => this.hideToolTip('toTimeToolTip')}
                onClick={() => this.handleCopyValue('endTime', 'startTime')}>
                <Label className={styles.labelButton} title='End Time' />
                <Tooltip
                  target='#end-time-label'
                  position='top'
                  visible={this.state.toTimeToolTip}
                  hideOnOutsideClick={false}>
                  Copy Start Time
                </Tooltip>
              </div>

              <DateBox
                type='time'
                name={'endTime'}
                value={this.state['endTime']}
                placeholder={'HH:mm:ss.SSS'}
                showClearButton
                useMaskBehavior
                showDropDownButton={false}
                onValueChanged={(e) => this.handleChange(e, 'endTime')}
                displayFormat={filterTimePattern} /></div>

            <div key={'mpidKey'}>
              <Label title='MPID' />
              <TextBox
                name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isMpidFocus')}
                onFocusOut={() => this.handleFocusOut('isMpidFocus')}
                onValueChanged={(e) => this.handleChange(e, 'mpid')} />
              {isMpidFocus && recentMpidSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentMpidSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'mpid')} />
              </div>}

            </div>

            <div key={'sideKey'}>
              <Label title='Side' />
              <TagBox id={'side'}
                dataSource={sideTypes}
                showClearButton
                placeholder={'Side'}
                value={this.state['side']}
                displayExpr='value'
                valueExpr='id'
                name={'side'}
                multiline={false}
                showDropDownButton
                showSelectionControls
                wrapItemText
                maxDisplayedTags={2}
                showMultiTagOnly
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'side')} /></div>

            <div key={'venueKey'}>
              <Label title='Execution Venue' />
              <TagBox id={'venue'}
                dataSource={venueTypes}
                showClearButton
                placeholder={'Execution Venue'}
                value={this.state['venue']}
                displayExpr='value'
                valueExpr='id'
                name={'venue'}
                multiline={false}
                showDropDownButton
                showSelectionControls
                wrapItemText
                maxDisplayedTags={2}
                showMultiTagOnly
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'venue')} /></div>

            <div key={'orderCapacityKey'}>
              <Label title='Order Capacity' />
              <SelectBox id={'orderCapacity'}
                dataSource={capacityTypes}
                showClearButton
                placeholder={'Order Capacity'}
                value={this.state['orderCapacity']}
                displayExpr='value'
                valueExpr='id'
                name={'orderCapacity'}
                searchEnabled
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'orderCapacity')} /></div>

            <div key={'clientOrderIdKey'}>
              <Label title='Client Order ID' />
              <TextBox
                name={'clientOrderId'} placeholder={'Client Order ID'} value={this.state['clientOrderId']} showClearButton
                valueChangeEvent='keyup'
                onValueChanged={(e) => this.handleChange(e, 'clientOrderId')} /></div>

            <div key={'execIdKey'}>
              <Label title='Execution ID' />
              <TextBox
                name={'execId'} placeholder={'Execution ID'} value={this.state['execId']} showClearButton
                valueChangeEvent='keyup'
                onValueChanged={(e) => this.handleChange(e, 'execId')} /></div>

            <div key={'liquidityIndicatorKey'}>
              <Label title='Liquidity Indicator' />
              <SelectBox id={'liquidityIndicator'}
                dataSource={liquidityTypes}
                showClearButton
                placeholder={'Liquidity Indicator'}
                value={this.state['liquidityIndicator']}
                displayExpr='value'
                valueExpr='id'
                name={'liquidityIndicator'}
                searchEnabled
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'liquidityIndicator')} /></div>

            <div key={'minSizeKey'}>
              <Label title='Min Trade Size' />
              <NumberBox mode='number'
                name={'minSize'} placeholder={'Min Trade Size'} value={this.state['minSize']} showClearButton
                valueChangeEvent='keyup' min={0}
                format={'###0'}
                onValueChanged={(e) => this.handleChange(e, 'minSize')} /></div>

            <div key={'maxSizeKey'}>
              <Label title='Max Trade Size' />
              <NumberBox mode='number'
                name={'maxSize'} placeholder={'Max Trade Size'} value={this.state['maxSize']} showClearButton
                valueChangeEvent='keyup' min={0}
                format={'###0'}
                onValueChanged={(e) => this.handleChange(e, 'maxSize')} /></div>
          </div>

          }

          {!isFilterOpen && <div className={styles.collapsedContainer}>

            {this.state.symbol && <span className={styles.field}>
              <Label title='Symbol: ' isInline /> {this.state.symbol}
            </span>}
            <span className={styles.field}>
              <Label title='Date: ' isInline /> {this.renderCollapseDate()}
            </span>
            {this.state.mpid && <span className={styles.field}>
              <Label title='MPID: ' isInline /> {this.state.mpid}
            </span>}
            {this.state.side && this.state.side.length > 0 && <span className={styles.field}>
              <Label title='Side: ' isInline /> {this.renderCollapseSide()}
            </span>}
            {this.state.venue && this.state.venue.length > 0 && <span className={styles.field}>
              <Label title='Execution Venue: ' isInline /> {this.renderCollapseVenue()}
            </span>}
            {this.state.orderCapacity && <span className={styles.field}>
              <Label title='Order Capacity: ' isInline /> {this.state.orderCapacity}
            </span>}
            {this.state.clientOrderId && <span className={styles.field}>
              <Label title='Client Order ID: ' isInline /> {this.state.clientOrderId}
            </span>}
            {this.state.execId && <span className={styles.field}>
              <Label title='Execution ID: ' isInline /> {this.state.execId}
            </span>}
            {this.state.liquidityIndicator && <span className={styles.field}>
              <Label title='Liquidity Indicator: ' isInline /> {this.state.liquidityIndicator}
            </span>}
            {(this.state.minSize || this.state.maxSize) && <span className={styles.field}>
              <Label title='Trade Size: ' isInline /> {this.renderCollapseSize()}
            </span>}
          </div>}

          <div className={styles.controls}>
            {isFilterOpen && <Button title='Search' onClick={this.handleSearch} size='extraSmall' /> }
            <Button title='Excel' size='extraSmall' inactive={this.props.isDownloadInactive} onClick={this.handleDownload} />
            {this.props.isDownloadInactive && <span> Downloading...</span>}
            {isFilterOpen && <div className={styles.collapseOption}>
              <CheckBox
                width='100%'
                text='Collapse filters upon search results'
                onValueChanged={this.handleCollapseOption}
                value={this.state.collapseOnSearch}
              />
            </div> }
          </div>
          <div className={styles.errorMessages}>
            {this.state.errorMessages.length > 0 && this.renderErrorMessages()}
          </div>

          <div className={styles.toggle} onClick={this.toggleFilter}>
            {this.state.showFilter && <FaAngleDoubleUp />}
            {!this.state.showFilter && <FaAngleDoubleDown />}
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(TradeFilter);

TradeFilter.propTypes = {
  search: PropTypes.func,
  startDateUpdate: PropTypes.string,
  endDateUpdate: PropTypes.string,
  mpidUpdate: PropTypes.string,
  isDownloadInactive: PropTypes.bool,
  isDataLoaded: PropTypes.bool

};
